import { graphql } from "@/gql";

export const createProDriverMutation = graphql(`
  mutation CreateProDriver($input: CreateProDriverInput!) {
    createProDriver(input: $input) {
      id
      name
      email
      phone
      date_of_birth
      bio
      license_type
      basedIn {
        id
        name
      }
    }
  }
`);

export const emailProDriversMutation = graphql(`
  mutation EmailPaidPaidDrivers($input: EmailProDriversInput!) {
    emailProDrivers(input: $input)
  }
`);

export const updateProDriverMutation = graphql(`
  mutation UpdatePaidDriver($id: ID!, $input: UpdateProDriverInput!) {
    updateProDriver(id: $id, input: $input) {
      id
    }
  }
`);

export const deleteProDriverMutation = graphql(`
  mutation DeletePaidDriver($id: ID!) {
    deleteProDriver(id: $id) {
      id
    }
  }
`);
